export const seg = (p, a, b) => Math.min(1, Math.max(0, (p - a) / (b - a)));

export function Window({ title, children, className = "", right }) {
  return (
    <div className={`flex h-full w-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0B0D13] shadow-[0_50px_100px_-40px_rgba(0,136,255,0.35)] ${className}`}>
      <div className="flex items-center gap-2 border-b border-white/[0.07] px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <span className="h-2.5 w-2.5 rounded-full bg-white/15" />
        <p className="ml-2 truncate font-mono text-[11px] text-slate-400">{title}</p>
        <div className="ml-auto">{right}</div>
      </div>
      <div className="relative min-h-0 flex-1">{children}</div>
    </div>
  );
}

export function Phone({ children, className = "" }) {
  return (
    <div className={`relative aspect-[9/19] h-full max-h-full rounded-[2.2rem] border border-white/15 bg-black p-[7px] shadow-[0_40px_80px_-30px_rgba(0,0,0,0.9)] ${className}`}>
      <div className="relative h-full w-full overflow-hidden rounded-[1.8rem] bg-[#0B0D13]">
        <div className="absolute left-1/2 top-1.5 z-30 h-[18px] w-[34%] -translate-x-1/2 rounded-full bg-black" />
        {children}
      </div>
    </div>
  );
}

export function Tag({ children, className = "" }) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.14em] text-slate-300 ${className}`}>{children}</span>;
}
